import { Component } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from '@angular/router';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
  standalone: false

})
export class AboutUsComponent {
  constructor(private location: Location, private router: Router) {}

  
  public goBack() {
      this.location.back();
  }

  public navigateToProducts() {
        this.router.navigate(["/products"]);
    }

    public navigateToContact() {
        this.router.navigate(["/contact"]);
    }
}
